import {
  FileText,
  CheckSquare,
  AlertCircle,
  FolderOpen,
  Home,
  Tags,
  MessageCircleMore,
  Ticket,
  LayoutDashboard,
} from 'lucide-react';
import { Users, Settings } from 'lucide-react';

import type { NavItem, NavSection } from '@/types/sidebar';

export const homeItems: NavItem[] = [
  {
    icon: Home,
    label: 'Dashboard',
    href: '/dashboard',
  },
  {
    icon: Users,
    label: 'Contacts',
    href: '/contacts',
  },
  {
    icon: FolderOpen,
    label: 'Media',
    href: '/media',
  },
  {
    icon: LayoutDashboard,
    label: 'Management',
    href: '/management',
  },
  {
    icon: Settings,
    label: 'Settings',
    href: '/settings',
  },
];

export const messageItems: NavItem[] = [
  {
    icon: Users,
    label: 'Groups',
    href: '/groups',
  },
  {
    icon: MessageCircleMore,
    label: 'DMs',
    href: '/inbox',
  },
  {
    icon: Users,
    label: 'Communities',
    href: '/communities',
  },
];

export const aiItems: NavItem[] = [
  // {
  //   icon: Zap,
  //   label: 'Workflows',
  //   href: '/automation',
  // },
  {
    icon: Tags,
    label: 'Tags',
    href: '/tags',
  },
  {
    label: 'Tickets',
    icon: Ticket,
    href: '/tickets',
  },
];

export const viewItems: NavItem[] = [
  {
    label: 'Audit Trial',
    icon: FileText,
    href: '/audit-trial',
  },
  {
    label: 'SLA Tracker',
    icon: CheckSquare,
    href: '/sla-tracker',
  },
  {
    label: 'Issues',
    icon: AlertCircle,
    href: '/issues',
  },
];

export const navSections: NavSection[] = [
  {
    title: 'Home',
    items: homeItems,
  },
  {
    title: 'Messages',
    items: messageItems,
  },
  {
    title: 'AI',
    items: aiItems,
  },
  // {
  //   title: 'Views',
  //   items: viewItems,
  // },
];
